import { useTheme } from '@mui/material';

export const IntroIcon5 = ({ className }: { className: string }) => {
    const theme = useTheme();
    const {
        stroke: { primary: primaryStroke },
    } = theme.colors.other.icon;

    return (
        <svg
            className={className}
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
        >
            <path
                d="M3.42857 2.57631C2.95714 2.57631 2.57143 2.96203 2.57143 3.43345V20.5763C2.57143 21.0477 2.95714 21.4335 3.42857 21.4335H20.5714C21.0429 21.4335 21.4286 21.0477 21.4286 20.5763V3.43345C21.4286 2.96203 21.0429 2.57631 20.5714 2.57631H3.42857ZM0 3.43345C0 1.54238 1.5375 0.00488281 3.42857 0.00488281H20.5714C22.4625 0.00488281 24 1.54238 24 3.43345V20.5763C24 22.4674 22.4625 24.0049 20.5714 24.0049H3.42857C1.5375 24.0049 0 22.4674 0 20.5763V3.43345ZM9.85714 16.2906H11.1429V12.862H9.85714C9.14464 12.862 8.57143 12.2888 8.57143 11.5763C8.57143 10.8638 9.14464 10.2906 9.85714 10.2906H12.4286C13.1411 10.2906 13.7143 10.8638 13.7143 11.5763V16.2906H14.1429C14.8554 16.2906 15.4286 16.8638 15.4286 17.5763C15.4286 18.2888 14.8554 18.862 14.1429 18.862H9.85714C9.14464 18.862 8.57143 18.2888 8.57143 17.5763C8.57143 16.8638 9.14464 16.2906 9.85714 16.2906ZM12 5.14774C12.4547 5.14774 12.8907 5.32835 13.2122 5.64984C13.5337 5.97133 13.7143 6.40737 13.7143 6.86203C13.7143 7.31668 13.5337 7.75272 13.2122 8.07421C12.8907 8.3957 12.4547 8.57631 12 8.57631C11.5453 8.57631 11.1093 8.3957 10.7878 8.07421C10.4663 7.75272 10.2857 7.31668 10.2857 6.86203C10.2857 6.40737 10.4663 5.97133 10.7878 5.64984C11.1093 5.32835 11.5453 5.14774 12 5.14774Z"
                fill={primaryStroke}
            />
        </svg>
    );
};
